import {
 Mail, MessageSquare, Mic
} from 'lucide-react';
import {
 FaWhatsapp, FaFacebookMessenger
} from 'react-icons/fa';

interface ChannelTypeSelectionProps {
  onSelect: (type: string) => void;
  selectedType?: string;
  disabled?: boolean;
}

const channelTypes = [
  {
    id: 'Email',
    name: 'Email',
    icon: Mail,
    description: 'Microsoft 365 or SMTP/IMAP',
    color: 'text-blue-500',
    bgColor: 'bg-blue-50 dark:bg-blue-900/20',
  },
  {
    id: 'Web Chat',
    name: 'Web Chat',
    icon: MessageSquare,
    description: 'Embed chat on your site',
    color: 'text-indigo-500',
    bgColor: 'bg-indigo-50 dark:bg-indigo-900/20',
  },
  {
    id: 'WhatsApp',
    name: 'WhatsApp',
    icon: FaWhatsapp,
    description: 'Connect via WhatsApp Business',
    color: 'text-green-500',
    bgColor: 'bg-green-50 dark:bg-green-900/20',
  },
  {
    id: 'Messenger',
    name: 'Messenger',
    icon: FaFacebookMessenger,
    description: 'Connect via Facebook Messenger',
    color: 'text-blue-600',
    bgColor: 'bg-blue-50 dark:bg-blue-900/20',
  },
  {
    id: 'Voice',
    name: 'Voice',
    icon: Mic,
    description: 'Voice channel integration',
    color: 'text-orange-500',
    bgColor: 'bg-orange-50 dark:bg-orange-900/20',
  },
];

export const ChannelTypeSelection: React.FC<ChannelTypeSelectionProps> = ({
  onSelect,
  selectedType,
  disabled
}) => {
  return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {channelTypes.map((type) => {
        const Icon = type.icon;
        const isSelected = selectedType === type.id;

        return (
            <button
            key={type.id}
            onClick={() => !disabled && onSelect(type.id)}
            disabled={disabled}
            className={`
              relative flex flex-col items-start p-4 rounded-xl border-2 transition-all duration-200 text-left
              ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:border-blue-500 hover:shadow-md'}
              ${isSelected ? 'border-blue-500 bg-blue-500/10' : 'border-border bg-card'}
            `}
          >
                <div className={`p-3 rounded-lg mb-3 ${type.bgColor}`}>
                    <Icon className={`w-6 h-6 ${type.color}`} />
                </div>
                <h3 className="font-semibold text-foreground mb-1">{type.name}</h3>
                <p className="text-sm text-muted-foreground">{type.description}</p>

                {isSelected && (
                <div className="absolute top-3 right-3 w-3 h-3 bg-blue-500 rounded-full ring-2 ring-background" />
            )}
            </button>
        );
      })}
      </div>
  );
};
